<template>
  <v-app id="selectLanguage" class :style="'background:url('+background+')'">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm12 md12 lg12>
            <v-card>
              <v-card-text>
                <div class="layout column align-center">
                  <img src="/static/languages.png" alt="Logo Here" width="220">
                  <!-- <h1 class="flex my-4 primary--text">{{ $vuetify.t('$vuetify.select_visa_type') }}</h1> -->
                </div>
                <v-form ref="form" v-model="valid" lazy-validation class="pa-2">
                  <v-layout>
                    <v-flex class="ma-2">
                      <h2
                        class="flex my-4 primary--text"
                      >{{ $vuetify.t('$vuetify.select_language') }}</h2>
                      <v-select
                        :label="$vuetify.t('$vuetify.select_language') "
                        :rules="[rules.required]"
                        :items="languages"
                        outlined
                        v-model="selected"
                        :clearable="true"
                        @change="select"
                      ></v-select>
                    </v-flex>
                    <v-flex class="ma-2">
                      <h2
                        class="flex my-4 primary--text"
                      >{{ $vuetify.t('$vuetify.select_country') }}</h2>
                      <v-select
                        :label="$vuetify.t('$vuetify.select_country')"
                        :rules="[rules.required]"
                        :items="nationalitiesOptions"
                        outlined
                        @change="selectNationality"
                        v-model="nationalitySelected"
                        :clearable="true"
                      ></v-select>
                    </v-flex>
                    <v-flex class="ma-2">
                      <h2
                        class="flex my-4 primary--text"
                      >{{ $vuetify.t('$vuetify.select_visa_type') }}</h2>
                      <v-select
                        :label="$vuetify.t('$vuetify.select_visa_type')"
                        :rules="[rules.required]"
                        :items="visaOptions"
                        outlined
                        v-model="visaSelected"
                        :clearable="true"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-btn
                  block
                  color="primary"
                  @click="visaSelect"
                  :loading="visaLoading"
                >{{ $vuetify.t('$vuetify.proceed') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
export default {
  data() {
    return {
      background: require("@/assets/background.jpg"),
      stepper: 0,
      loading: false,
      selected: null,
      nationalitySelected: null,
      visaSelected: "tourist-visa",
      valid: false,
      rules: {
        required: value => !!value || "Required."
      },
      languages: [
        {
          text: "English",
          value: "en"
        },
        {
          text: "Nepali",
          value: "np"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      nationalityLoading: "NationalityList/loading",
      visaLoading: "VisaTypeList/loading"
    }),
    visas: {
      get() {
        return this.$store.state.VisaTypeList.all;
      },
      set(value) {}
    },
    visaOptions: {
      get() {
        // let vt = _.clone(this.visas);
        // vt = vt.map(r => {
        //   return {
        //     text: r.type,
        //     value: r.slug
        //   };
        // });
        // return vt;
        return [
          {
            text: "Tourist Visa",
            value: "tourist-visa"
          }
        ];
      }
    },
    nationalities: {
      get() {
        return this.$store.state.NationalityList.all;
      },
      set(value) {}
    },
    nationalitiesOptions: {
      get() {
        let vt = _.clone(this.nationalities);
        vt = vt.map(r => {
          return {
            text: r.country_name,
            value: r.id
          };
        });
        return vt;
      }
    }
  },
  methods: {
    ...mapActions({
      fetchAllNationalities: "NationalityList/fetchAll",
      fetchAllVisas: "VisaTypeList/fetchAll"
    }),
    selectNationality(event) {
      const self = this;
      this.$store.commit("NationalityList/setCurrent", event);
      // this.$router.push({ name: "SelectVisa" });
      self.fetchAllVisas(event);
    },
    visaSelect() {
      if (this.$refs.form.validate()) {
        this.$router.push({
          name: "VisaApplication",
          params: { type: this.visaSelected }
        });
      }
    },
    select(event) {
      this.$vuetify.lang.current = "" + event;
      this.fetchAllNationalities();
    }
  },
  mounted() {}
};
</script>
<style scoped lang="css">
#selectLanguage {
  height: 70%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
  background-origin: content-box !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
}
</style>
